module.exports = __webpack_public_path__ + "img/604.fd9275d3.jpg";